import styled from "styled-components";
import TextContent from "~/componentes/TextContent";
import { Colors } from "~/config/Colors";

export const Container = styled.div`
  display: flex;
  align-items: center;
  max-width: 100%;

  .ColoredFileInput_Container_button {
    margin: 0em 0.5rem 0 0;
    height: 2.3rem;
  }

  .ColoredFileInput_Container_icons {
    display: flex;
    align-items: center;
    margin-left: 0.5rem;

    i {
      color: #7b898c;
      font-size: 1.5rem;
    }
  }

  button {

  }
`;

export const FileName = styled(TextContent)`
  font-size: 0.5rem;
  height: 100%;
  line-height: 2rem;
  border: solid 0.3rem ${Colors.Color23};
  border-radius: 1.1rem;

  width: 100%;
  max-width: 100%;
  padding-left: 0.5rem;

  background-color: ${Colors.Color23};
  color: ${Colors.Color7} !important;
`;
